import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getClasificacionesGrupoTemporada } from '../../services/clasificacionService';
import { getJornadasByIdGrupoAndTemporada } from '../../services/jornadasService';
import { teamDirectorySummary } from '../../utils/teamDirectory';

export default function TeamDirectorySummary({ teamId, season, context }) {
  const { t } = useTranslation('directories');
  const navigate = useNavigate();
  const standings = useQuery({
    queryKey: ['clasificacion', season, context.idCompeticion, context.idGrupo],
    queryFn: () => getClasificacionesGrupoTemporada(season, context.idGrupo, navigate),
    staleTime: 5 * 60 * 1000, retry: false,
  });
  const calendar = useQuery({
    queryKey: ['jornadas', context.idGrupo, season],
    queryFn: () => getJornadasByIdGrupoAndTemporada(context.idGrupo, season, navigate),
    staleTime: 5 * 60 * 1000, retry: false,
  });
  const summary = teamDirectorySummary(teamId, standings.data, calendar.data);
  return <div className="dr-team-summary">
    <p className="dr-muted">{[context.nombreCompeticion, context.nombreGrupo].filter(Boolean).join(' · ')}</p>
    {(standings.isLoading || calendar.isLoading) && <p role="status">{t('loading')}</p>}
    {(standings.isError || calendar.isError) && <p role="alert">{t('loadError')} <Button onClick={() => {
      standings.refetch(); calendar.refetch();
    }}>{t('retry')}</Button></p>}
    <dl className="dr-kpis"><div><dt>{t('rank')}{summary.round != null && ` · ${t('round', { round: summary.round })}`}</dt><dd>{summary.position ?? '—'}</dd></div>
      <div><dt>{t('points')}</dt><dd>{summary.points ?? '—'}</dd></div>
      <div><dt>{t('form')}</dt><dd>{summary.form.length ? summary.form.map((result) => t(`result.${result}`)).join(' · ') : '—'}</dd></div>
    </dl>
    <p><strong>{t('nextMatch')}: </strong>{summary.next
      ? `${summary.next.equipoLocal} · ${summary.next.equipoVisitante} · ${summary.next.fecha}` : t('noNextMatch')}</p>
  </div>;
}
